/* eslint-disable */
import { some } from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import { VueAutosuggest } from 'vue-autosuggest';
import loaderMixin from '@/mixins/loader';
import { formMixin } from '@/components/forms/mixin';

const OTHER_ID = -1;
const LIMIT = 10;

export default {
  mixins: [
    formMixin,
    loaderMixin,
  ],
  data() {
    return {
      showExplanation: false,
      isSearching: false,
      suggestions: [
        { data: [] },
      ],
      current: [],
      currentIds: [],
      fields: {
        query: '',
        agreed: '',
      },
    };
  },
  components: {
    VueAutosuggest,
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapState('user', ['status']),
    universities() {
      return this.current;
    },
    isConfirmDisabled() {
      const isOneOfFieldsEmpty = some(this.current, x => !x.name);
      return !this.isFormEnabled || !this.fields.agreed || isOneOfFieldsEmpty;
    },
    showOtherSchoolNote() {
      return this.currentIds.includes(OTHER_ID);
    },
    buttonText() {
      return this.status.isUCAffilSet === null ? 'Continue' : 'Confirm';
    }
  },
  watch: {
    'fields.agreed' (value) {
      if (value === 'no') {
        this.fields.query = '';
      }
    },
  },
  methods: {
    ...mapActions('profile', [
      'getUserAffiliations', 'setUserAffiliations', 'getAffiliations',
    ]),
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('user', ['getStatus']),
    onClick(suggestion) {
      if (this.isLayoutMobile) return;
      this.onSelected(suggestion)
    },
    onMouseDown(suggestion) {
      if (!this.isLayoutMobile) return;
      this.onSelected(suggestion);
    },
    onRemove(value) {
      this.current = this.current.filter(i => i.id !== value.id);
      this.currentIds = this.currentIds.filter(i => i !== value.id);
    },
    getKey() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
    onSelected(value) {
      if (!value || !value.item || this.currentIds.length === LIMIT) {
        return;
      }
      const item = value.item;
      if (item && (item.id === OTHER_ID || !this.currentIds.includes(item.id))) {
        this.currentIds.push(item.id);
        this.current.push({...item});
        // this.fields.query = item.name;
      }

      if (item && item.id === OTHER_ID) {
        this.$nextTick(() => {
          const elements = this.$el.querySelectorAll('.input__value');
          if (elements.length > 0) {
            elements[elements.length - 1].focus();
          }
        });
      }

      // this.$nextTick(() => {
      //   this.fields.query = '';
      //   if (this.$refs.autosuggest) {
      //     this.$refs.autosuggest.searchInputClose();
      //   }
      // });
      // this.suggestions[0].data = [];
    },
    onInputChange(text) {
      if (this.isSearching) return;

      if (this.fields.query && this.fields.query.length >= 2) {
        this.isSearching = true;
        setTimeout(() => {
          this.getAffiliations(this.fields.query)
            .then((data) => {
              this.suggestions[0].data = (data.affiliateEntities || []).map((i) => {
                return {
                  id: i.affiliateEntityId,
                  isHidden: false,
                  name: i.name,
                  key: this.getKey()
                };
              });
              this.isSearching = false;
            })
            .catch(() => {
              this.isSearching = false;
            });
        }, 500);
      }
    },
    getSuggestionValue(suggestion) {
      return suggestion.item.name;
    },
    onSubmit() {
      this.formDisable();
      this.loaderAdd(document.body);

      let affiliations = [];

      if (this.fields.agreed === 'yes') {
        this.universities.forEach((i) => {
          const item = {
            id: i.id,
            name: i.id === -1 ? i.name: '',
            isPublic: !i.isHidden,
          };
          affiliations.push({...item})
        });
      } else {
        affiliations = [];
      }
      const payload = {
        isUCAffiliated: this.fields.agreed === 'yes',
        userAffiliations: affiliations,
      };

      this.setUserAffiliations(payload)
        .then(() => this.getStatus())
        .then(() => this.getUserAffiliations())
        .then(() => {
          // Emit event for parent to handle (allows registration flow interception)
          this.$emit('affiliationsSubmitted');
        })
        .then(() => {
          this.loaderRemove(document.body);
          this.formEnable();
        })
        .catch(() => {
          this.loaderRemove(document.body);
          this.formEnable();
        });
    },
  },
  mounted() {
    this.loaderAdd();
    this.getUserAffiliations()
      .then((data) => {
        (data.affiliateEntities || []).forEach((i) => {
          this.currentIds.push(i.affiliateEntityId);
          const item = {
            id: i.affiliateEntityId,
            isHidden: !i.isPublic,
            name: i.name,
            key: this.getKey()
          };
          this.current.push({...item});
        });
        if (this.status.isUCAffilSet === true) {
          this.fields.agreed = 'yes';
        } else if (this.status.isUCAffilSet === false) {
          this.fields.agreed = 'no';
        }
        this.loaderRemove();
      })
      .catch(() => this.loaderRemove());
  },
};



// WEBPACK FOOTER //
// ./src/components/profile/affiliations-popup/affiliations-popup.js